<div class="d-flex justify-content-center align-items-center" style="height: 50vh;">
    <div class="d-flex justify-content-center">
      <div class="lds-facebook">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
  
  
  